export const ExclusiveEmptyCard = () => {
  return (
    <div className="overflow-hidden relative h-[var(--card-height)] rounded content-center border border-white/[10%] grid place-items-center">
      <div className="relative z-10 flex flex-col items-center justify-center gap-2 max-w-48 text-center">
        <h2>No Unlocks</h2>
        <p className="text-sm text-gray-11">Claim items to unlock "Play" and bonus content.</p>
      </div>
    </div>
  )
}
